<template>
  <div class="page">

    <Modal @close="keyBack">
      <p slot="header">{{ $t('ERROR-SUBCRIPTION.TITLE') }}</p>
      <p slot="body">
        {{ $tc('ERROR-SUBCRIPTION.MSG', $store.getters.getData.is_app_mobile) }}
        <a  class="url" target="_blank" :href="url">{{url}}</a>
      </p>
    </Modal>

  </div>
</template>

<script>
import router from '@/router/index'
import Bus from '@/components/ControlBus'
import Modal from '@/components/Modal'
import { enviroment } from '@/utils/constants'
const auth = require('@/services/auth.js')

export default {
  name: 'SubcriptionError',
  components: { Modal },
  created: function () {
    if (!this.$store.getters.getData.is_subscriptions) {
      this.$router.replace({name: 'content'})
    }
  },
  mounted: function () {
    // keys control
    Bus.$on('key-back', this.keyBack)
  },
  methods: {
    keyBack () {
      auth.getToken(false, false).then(() => {
        auth.getUser().then(response => {
          this.$store.commit('setUser', response.data['results'][0])
          router.push({name: 'welcome'})
        })
      })
    }
  },
  beforeDestroy: function () {
    Bus.$off('key-back', this.keyBack)
  },
  computed: {
    url: function () {
      if (this.$store.getters.getData.login_url) {
        return this.$store.getters.getData.login_url
      }
      let env = enviroment
      if (enviroment === 'api' || enviroment === 'api-pinko') { env = 'portal' }
      return 'https://' + env + '.interactvty.com/tv/' + this.$store.getters.getData.name + '/'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
.url
  font-weight: bold
  color: inherit;
</style>



// WEBPACK FOOTER //
// src/pages/site/SubcriptionError.vue